

















































































import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class PundPSettings extends Vue {
  public availableBackgrounds: string[] = [
    'BackgroundVjorngard0.jpg',
    'BackgroundVjorngard1.jpg',
    'Background0.jpg',
    'Background1.jpg',
    'Background2.jpg',
    'Background3.jpg',
    'Background4.jpg',
    'Background5.jpg',
    'Background6.jpg',
    'Background7.jpg',
    'Background8.jpg',
    'Background9.jpg',
  ];
  private open: boolean = false;
  private selectedBackground: string = '';
  private selectedOpacity: number = 0;
  private originalBackground: string = '';
  private originalOpacity: number = 60;
  private accountDetails = {
    name: null,
    email: null,
    saving: false,
  };

  public created(): void {
    this.selectedBackground = this.activeBackground;
    this.selectedOpacity = this.opacity;
    this.originalBackground = this.activeBackground;
    this.originalOpacity = this.opacity;
  }

  public mounted() {
    if (!this.isLoading) {
      this.onUserDataLoad(false, true);
    }
  }

  public createGroup(): void {
    this.$store.dispatch('createGroup', 'Neue Gruppe');
  }

  public saveAccountDetails() {
    this.accountDetails.saving = true;
    this.$store.dispatch('saveAccountDetails', this.accountDetails).then(() => {
      this.accountDetails.saving = false;
    });
  }

  public changeBackground(background: string) {
    this.selectedBackground = background;
  }

  public saveBackground() {
    const payload = {
      background: this.selectedBackground,
      opacity: this.selectedOpacity,
    };
    this.$store.dispatch('changeBackground', payload).then(() => {
      this.originalBackground = this.activeBackground;
      this.originalOpacity = this.opacity;
    });
  }

  public resetBackground() {
    this.selectedBackground = this.originalBackground;
    this.selectedOpacity = this.originalOpacity;
  }

  private getBackground(background: string) {
    return require('@/assets/css/background/' + background);
  }

  @Watch('selectedOpacity')
  @Watch('selectedBackground')
  private onOpacityChanged(newValue: number, oldValue: number) {
    const payload = {
      background: this.selectedBackground,
      opacity: this.selectedOpacity,
    };
    this.$store.commit('changeBackground', payload);
  }

  @Watch('isLoading')
  private onUserDataLoad(newValue: boolean, oldValue: boolean) {
    if (!newValue) {
      this.originalBackground = this.activeBackground;
      this.originalOpacity = this.opacity;
      this.selectedBackground = this.activeBackground;
      this.selectedOpacity = this.opacity;
      this.accountDetails.name = this.$store.getters.userData.name;
      this.accountDetails.email = this.$store.getters.getUser.email;
    }
  }

  get isLoading(): boolean {
    return this.$store.getters.userData === null;
  }

  get settings(): object {
    return this.$store.getters.settings;
  }

  get groups(): object[] {
    return this.$store.getters.groups;
  }

  get groupInvitations(): object[] {
    return this.$store.getters.groupInvitations;
  }

  get activeBackground(): string {
    return this.$store.getters.backgroundImage;
  }

  get opacity(): number {
    return this.$store.getters.backgroundOpacity;
  }

  get changedBackground(): boolean {
    return this.selectedBackground !== this.originalBackground || this.selectedOpacity !== this.originalOpacity;
  }
}
